var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',{staticClass:"text-extra-extra-large text-center my-4 pb-3"},[[_vm._v("\n      Create OKRs with North AI\n    ")]],2)])}
var staticRenderFns = []

export { render, staticRenderFns }